import { Container } from "react-bootstrap";

function Footer() {

    return (
        <Container className="narrow-container-1">
            <div className="mb-5">
                <p className="lead">
                    © Lisa Mekioussa Malki
                </p>
            </div>
        </Container>
    );

}
export default Footer;